/**
 * Mapping des routes admin temporaires en attendant la refonte des pages admin en V10.
 * La map permet de limiter un peu les bidouilles via l'URL tout en autorisant la compréhension de la route.
 * L'URL conserve une signification et les utilisateurs peuvent copier-coller en conservant la page si besoin.
 * TODO: A nettoyer pour chaque nouvelle page admin V10 et à supprimer une fois toutes les pages portées en V10
 * */
export const FRAME_ROUTES: Map<string,{ path: string, idParam?: boolean}> = new Map([
    ["/Admin/Entreprise/Populations", { path: "controller/Population?action=listePopulation" }],
    ["enveloppes", { path: "controller/Analytique?action=consult" }],
    ["externes", { path: "servlet/NDFServlet#/Externes/consult?tab=0" }],
    ["parametres1", { path: "servlet/NDFServlet#/Externes/consult?tab=1" }],
    ["motifs", { path: "servlet/NDFServlet#/WorkflowMotif" }],
    ["mails", { path: "servlet/NDFServlet#/Mail/configSMTP" }],
    ["messages", { path: "controller/Notification?action=liste&tab=id_bloc_liste_notifications" }],
    ["relances", { path: "controller/Notification?action=liste&tab=id_bloc_relances" }],
    ["typeEntite1", { path: "controller/TypeEntite?action=liste" }],
    ["zonesPredefinies", { path: "controller/ZoneUtilisateur?tab=id_zones_predefinies" }],
    ["zonesParametrables", { path: "controller/ZoneUtilisateur?tab=id_zones_parametrables" }],
    ["rest", { path: "servlet/NDFServlet#/API/comptes/", idParam: true }],
    ["ordonnanceur", { path: "servlet/NDFServlet#/Ordonnanceur/listeOrdo" }],
    ["fournisseurs", { path: "servlet/NDFServlet#/Contrat/listeFournisseur" }],
    ["typesCharges", { path: "servlet/NDFServlet#/Interfaces/Referentiels?tab=2" }],
    ["tolerances", { path: "servlet/NDFServlet#/Interfaces/Configuration?tab=2" }],
    ["fraisMissions", { path: "servlet/NDFServlet#/IndemnitesJournalieres?tab=0" }],
    ["fraisMissionDetail", { path: "servlet/NDFServlet#/IndemnitesJournalieres/FraisMission/", idParam: true }],
    ["fraisAttribution", { path: "servlet/NDFServlet#/IndemnitesJournalieres?tab=1" }],
    ["fraisAttributionRegle", { path: "servlet/NDFServlet#/IndemnitesJournalieres/RegleAttribution/", idParam: true }],
    ["fraisAbattements", { path: "servlet/NDFServlet#/IndemnitesJournalieres?tab=2" }],
    ["fraisParametres", { path: "servlet/NDFServlet#/IndemnitesJournalieres?tab=3" }],
    ["taxes", { path: "servlet/NDFServlet#/Taxe/param?tab=0" }],
    ["domaines", { path: "servlet/NDFServlet#/Taxe/param?tab=1" }],
    ["/Admin/Voyages/FraisAgence", { path: "servlet/NDFServlet#/FraisAgence" }],
    ["alertes", { path: "servlet/NDFServlet#/Alerte/liste" }],
    ["conditions", { path: "servlet/NDFServlet#/Condition/liste" }],
    ["wfControle",{path: "servlet/NDFServlet#/Workflow/controle"}],
    ["/Admin/Workflow/Motifs", { path: "servlet/NDFServlet#/WorkflowMotif" }],
    ["/Admin/Workflow/Roles", { path: "servlet/NDFServlet#/Role/liste" }],
    ["/Admin/Workflow/Statuts", { path: "servlet/NDFServlet#/Statut/liste/0" }],
    ["/Admin/Maintenance/CompteAdmin", { path: "servlet/NDFServlet#/Maintenance/CompteAdmin" }],
    ["/Admin/Maintenance/GestionLogs", { path: "servlet/NDFServlet#/Logging/configLogging" }],
    ["distances", { path: "controller/Geographie?tab_index=7"}],
    ["traductionMessages", { path: "controller/I18n?tab=id_bloc_liste_messages"}],
    ["traductionReferentiels", { path: "controller/I18n?tab=id_bloc_liste_referentiels"}],
    ["codesMCC", { path: "servlet/NDFServlet#/Interfaces/Referentiels?tab=1" }],
    ["utilisateursMessage", { path: "controller/Notification?action=liste&tab=id_bloc_profil_config" }]
]);
